import { render, staticRenderFns } from "./BusinessAccountData.vue?vue&type=template&id=3bafe3eb"
import script from "./BusinessAccountData.vue?vue&type=script&lang=js"
export * from "./BusinessAccountData.vue?vue&type=script&lang=js"
import style0 from "./BusinessAccountData.vue?vue&type=style&index=0&id=3bafe3eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports